export const ERROR_AUTH = 'common.alert.error.auth';
export const ERROR_CERTIFICATE = 'common.alert.error.certificate';
export const ERROR_FB_CERTIFICATE = 'common.alert.error.certificateFb';
export const ERROR_ACCOUNTORPWD = 'common.alert.error.accountOrPwd';
export const ERROR_REPORT_NOT_FOUND = 'common.alert.error.reportNotFound';

export const ERROR_SYSTEMCONNECT = '系統連線錯誤，請聯繫系統管理員處理。';
export const ERROR_CUSTOM_EXPRESSION = '公式有誤，請重新確認。';
export const ERROR_CHECK_FORM = '表單資料有誤，請重新確認。';
export const ERROR_SYSTEM_PROCESSING = '系統處理中，請稍後再試。';
export const ERROR_CSRF_MISMATCH = 'common.alert.error.csrfMisMatch';
export const TIP_DATA_LOADING = 'common.alert.tip.dataLoading';

export const LOGOUT_SUCCESS = 'common.alert.tip.logoutSuccess';
export const CANCEL_REQUEST = 'cancelRequest';

export const ALERT_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error'
}

